import {AbstractUpload} from "./AbstractUpload";
import {Projeto} from "../../../domain/Projeto";
import {ProjetoHttpService} from "../../persist/http/ProjetoHttpService";
import {Injectable} from "@angular/core";
import LocalDataSource from "../../../data-sources/LocalDataSource";
import {EnumSincronizacao} from "../../../domain/EnumSincronizacao";
import {Jornada} from "../../../domain/Jornada";

@Injectable()
export class UploadProjeto extends AbstractUpload<Projeto>{
  constructor(service: ProjetoHttpService) {
    super("Projeto", service, Projeto);
  }

  override async getPendencias(): Promise<any[]>{
    const repo = LocalDataSource.getRepository(Projeto)
    return repo.find({
      where: {situacao: EnumSincronizacao.ENVIAR},
      relations: ["metodologias","campanhas","local"]
    })
  }

  override transformBeforeSend(items: Projeto[]): any[]{
    items.forEach(i=>{
      delete i.situacao
      // i.local = i.local {id: i.local?.id}
    })
    return items
  }
}
